<template>
  <b-modal :id="id" :title="id" size="xl" lazy centered
           body-class="w-100 p-0" content-class="p-0" hide-header hide-footer @show="load">
    <template #default>
      <b-overlay :show="true" bg-color="white" opacity="1" style="min-height: 100px; padding: 0;" class="p-0">
        <template v-if="!studentEvents.loading">
            <b-table-simple v-for="bus in buses" :key="bus.id" responsive caption-top class="bus-roster p-0 d-none d-print-block">
              <caption class="p-0">
                <div class="d-flex justify-content-center gap-1">
                  <b-img :src="logo" class="print-logo" alt="Logo" style="max-width: 40px; max-height: 40px;"/>
                  <div class="text-body d-flex flex-column align-self-center">
                    <div class="font-weight-bold font-medium-3 line-height-1">Bus Roster</div>
                    <div class="font-weight-bold font-small-4">All-State - {{ $store.getters['settings/getCurrentYear'] }}</div>
                  </div>
                </div>
              </caption>
              <b-thead>
                <b-tr class="p-0">
                  <b-th colspan="2" class="text-left font-weight-bolder font-small-1 py-0 line-height-1">Bus {{ bus.name }}</b-th>
                  <b-th colspan="2" class="text-right font-weight-bolder font-small-1 py-0 line-height-1">{{ getStudentEventsForBus(bus.id).length }} Students</b-th>
                </b-tr>
                <b-tr class="p-0">
                  <b-th class="col-25-percent font-small-1">Student</b-th>
                  <b-th class="col-20-percent font-small-1">Ensemble</b-th>
                  <b-th class="col-15-percent font-small-1 text-center">Checkin Status</b-th>
                  <b-th class="font-small-1">Note</b-th>
                </b-tr>
              </b-thead>
              <b-tbody class="border-0">
                <b-tr v-for="event in getStudentEventsForBus(bus.id)" :key="event.id"
                      style="max-height: 12px; height: 12px; min-height: 12px;"
                      :data="application = event.student ? getApplicationWithSelection(event.student.applications) : null">
                  <b-td>
                    <span v-if="event.student" class="font-small-1">
                      {{ getFullName(event.student, { lnf: true, usePreferred: true }) }}
                    </span>
                    <span v-else class="text-danger font-small-1">
                      No Student
                    </span>
                  </b-td>
                  <b-td>
                    <span v-if="application && application.selection && application.selection.ensemble" class="font-small-1">
                       {{ application.selection.ensemble.name }}
                    </span>
                    <span v-else class="text-danger font-small-1">
                      Unknown Ensemble
                    </span>
                  </b-td>
                  <b-td class="text-center">
                    <b-icon v-for="n in 4" :key="n"
                            icon="square"
                            class="text-left px-0 align-items-start font-small-1"
                            :class="n !== 1 ? 'ml-1' : ''" style="width: 10px; height: 10px;"/>
                  </b-td>
                  <b-td class="font-small-1">
                    <span class="font-small-1">
                      {{ getBusNotesFromStudentEvent(event) }}
                    </span>
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </template>
        <template v-else>
          <b-card class="shadow-none m-0 p-0">
            <b-card-body>
              <!-- Card needed to give overlay some dimension -->
            </b-card-body>
          </b-card>
        </template>
      </b-overlay>
    </template>
  </b-modal>
</template>

<script>
import vSelect from 'vue-select'
import PageLayout from '@/components/PageLayout.vue';
import notify from '@/mixins/notify.mixin';
import OverlayLoading from '@/components/OverlayLoading.vue';
import Fuse from 'fuse.js';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import ApplicationDetails from '@/views/all-state/application/ApplicationDetails.vue';
import ApplicationStudent from '@/views/all-state/application/ApplicationStudent.vue';
import ApplicationQuestions from '@/views/all-state/application/ApplicationQuestions.vue';
import ApplicationGrading from '@/views/all-state/application/ApplicationGrading.vue';
import popper from '@/mixins/popper.mixin';
import BCardActions from '@core/components/b-card-actions/BCardActions.vue';
import TableRowOptions from '@/components/TableRowOptions.vue';
import settingsMixin from '@/mixins/settings.mixin';
import { getStudentEvents } from '@/views/events/service';
import events from '@/mixins/event.mixin';

export default {
  name: 'BusRosterModal',
  components: {
    TableRowOptions,
    BCardActions,
    ApplicationGrading,
    ApplicationDetails,
    ApplicationStudent,
    ApplicationQuestions,
    OverlayLoading,
    PageLayout,
    vSelect,
    VuePerfectScrollbar
  },
  mixins: [notify, popper, settingsMixin, events],
  props: {
    id: {
      type: String,
      required: false,
      default: null
    },
    buses: {
      type: Array,
      required: true,
      default: () => []
    },
    events: {
      type: Array,
      default: () => []
    },
    filters: {
      type: Object,
      default: () => ({
        ensembles: [],
        instruments: []
      })
    },
    sorting: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    /* eslint-disable global-require */
    return {
      logo: null,
      studentEvents: {
        loading: true,
        items: [ ],
      },
    }
  },
  watch: {
    events: {
      deep: true,
      handler(value) {
        this.studentEvents.items = value
      }
    },
  },
  mounted() {
    window.addEventListener('afterprint', this.handleAfterPrint);
  },
  beforeDestroy() {
    window.removeEventListener('afterprint', this.handleAfterPrint);
  },
  methods: {
    async refresh() {
      await this.listStudentEvents()
    },
    async load() {
      if(!this.events.length) {
        await this.listStudentEvents()
        this.studentEvents.items = this.sortItems({
          by: this.$props?.sorting?.by ?? ['student.name.last', 'student.name.first'],
          desc: this.$props?.sorting?.desc ?? false
        }, this.studentEvents.items)
      }
      else {
        this.studentEvents.items = this.events;
        this.studentEvents.items = this.sortItems({
          by: this.$props?.sorting?.by ?? ['student.name.last', 'student.name.first'],
          desc: this.$props?.sorting?.desc ?? false
        }, this.studentEvents.items)
        this.studentEvents.loading = false
      }

      if(!this.logo) {
        this.logo = require('@/assets/images/logo/logo5-blue-white-gold.svg');
      }

      this.$nextTick(() => {
        setTimeout(() => {
          window.print()
        }, 500);
      })
    },

    handleAfterPrint() {
      this.$bvModal.hide(this.id)
    },

    async listStudentEvents() {
      this.studentEvents.loading = true;
      await getStudentEvents({ includeNotes: true }).then(students => {
        this.studentEvents.items = students;
        this.studentEvents.loading = false;
        this.studentEvents.loaded = true;
      })
    },
    getStudentEventsForBus(busId) {
      return this.studentEvents?.items
        ?.filter(studentEvent => studentEvent.busId === busId)
        ?.filter(studentEvent => {
          const app = this.getApplicationWithSelection(studentEvent?.student?.applications)
          const { ensembles, instruments } = this.filters ?? {};
          if(ensembles?.length && app?.selection?.ensemble && !ensembles.includes(app?.selection?.ensemble?.id)) return false;
          if(instruments?.length && app?.instrument && !instruments.includes(app?.instrument?.id)) return false;
          return true;
        }) ?? []
    },
    getBusNotesFromStudentEvent(event) {
      return event.notes?.filter(note => note.type === 'bus').map(note => note.text).join(',')
    },
  }
}
</script>

<style lang="scss">

.bus-roster table {
  page-break-after: always;
  break-after: page;
}

.bus-roster caption {
  display: table-caption;
  margin: 0 auto 0 auto;
}

.bus-roster thead {
  page-break-before:unset!important;
  page-break-inside: unset!important;
  page-break-after:unset!important;
}

.bus-roster td {
  //background: red !important;
  padding-top: 1.4px !important;
  padding-bottom: 1.4px !important;
}


@media print {
  .print-logo {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    object-fit: cover;
    vertical-align: middle;
  }

  #app {
    visibility: hidden;
    display: none;
  }

  .modal {
    padding-left: 0 !important;
    position: relative;

    .modal-dialog {
      width: 100vw;
      max-width: none;
      margin: 0;

      span[tabindex] {
        visibility: hidden;
        display: none;
      }

      .modal-content {
        height: 100%;
        border: 0;

        .modal-body {
          padding: 0!important;
          overflow-y: visible;

          .b-overlay-wrap {
            overflow: hidden;

            .b-overlay {
              visibility: hidden;
              display: none;
            }
          }
        }
      }

      .modal-footer {
        visibility: hidden;
        display: none;
      }
    }
  }

  .modal-backdrop {
    visibility: hidden;
    display: none;
  }
}
</style>


